import { ReactNode } from 'react';
import {Row, Col, Card, CardHeader, CardBody} from 'reactstrap';
import Button from './Button';

interface SectionProperties {
  name: string;
  children?: ReactNode;
  onAdd?: () => void;
  addDisabled?: boolean;
}

const Section = function({
  name,
  children,
  onAdd,
  addDisabled = false
} : SectionProperties) {
  return (
    <Row className="mt-2 mb-3">
      <Col xs={12}>
        <Card>
          <CardHeader>
            <Row>
              <Col xs={10}>
                <h3>{name}</h3>
              </Col>
              { onAdd != null && (
                <Col xs={2} className="text-right">
                  <Button symbol="plus" shading="ghost" style="secondary" onClick={onAdd} disabled={addDisabled} />
                </Col>
              )}
            </Row>
          </CardHeader>
          <CardBody>
            {children}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default Section;